import axios from 'axios';

const runtimeConfig =
  typeof window !== 'undefined' && window.__APP_CONFIG__
    ? window.__APP_CONFIG__
    : {};

function resolveApiBaseUrl() {
  const configuredUrl = (runtimeConfig.API_BASE_URL || '').replace(/\/+$/, '');
  const isDevServer =
    typeof window !== 'undefined' &&
    (window.location.port === '8080' || window.location.port === '8081');

  if (isDevServer) {
    return '/api';
  }

  if (!configuredUrl) {
    throw new Error('API_BASE_URL is not configured in public/runtime-config.js');
  }

  return configuredUrl;
}

const API_BASE_URL = resolveApiBaseUrl();

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = false;

axios.interceptors.request.use((config) => {
  config.baseURL = API_BASE_URL;

  return config;
});

function clearAuthAndRedirect() {
  const keys = [
    'ACCESS_TOKEN',
    'ACCESS_TOKEN_EXPIRE',
    'USERNAME',
    'USERID',
    'SUPERADMIN',
    'USERTYPE',
    'PERMISSIONS',
    'LANGUAGE',
    'LANGUAGEID',
    'LANGUAGENAME',
    'BADGEHIDDEN',
  ];

  keys.forEach((key) => localStorage.removeItem(key));

  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
}

function handleUnauthorized(error) {
  if (error && error.response && error.response.status === 401) {
    clearAuthAndRedirect();
  }
  return Promise.reject(error);
}

axios.interceptors.response.use((response) => response, handleUnauthorized);

const httpClient = axios.create({
  baseURL: API_BASE_URL
});

httpClient.interceptors.request.use((config) => {
  config.baseURL = API_BASE_URL;

  return config;
});

httpClient.interceptors.response.use((response) => response, handleUnauthorized);

export default httpClient;
